import {
  CurrencyCell,
  ObservationCell,
  ReadOnlyCell,
  StatusCell,
} from "../../../shared/ui/review-table-cells";

export const getCatalogSupervisionColumns = () => [
  { title: "ID", dataIndex: "id", key: "id", width: 80, align: "center" },
  {
    title: "CODIGO PRODUCTO",
    dataIndex: "cod_id",
    key: "cod_id",
    width: 130,
    align: "center",
  },
  {
    title: "CATEGORIA",
    dataIndex: "category",
    key: "category",
    width: 220,
    ellipsis: false,
    render: (value) => <ReadOnlyCell value={value} />,
  },
  {
    title: "NOMBRE",
    dataIndex: "name",
    key: "name",
    width: 360,
    ellipsis: false,
    render: (value) => <ReadOnlyCell value={value} />,
  },
  {
    title: "DESCRIPCION",
    dataIndex: "description",
    key: "description",
    width: 300,
    ellipsis: false,
    render: (value) => <ReadOnlyCell value={value} />,
  },
  {
    title: "MARCA",
    dataIndex: "brand",
    key: "brand",
    width: 160,
    ellipsis: false,
    render: (value) => <ReadOnlyCell value={value} />,
  },
  {
    title: "UNIDAD",
    dataIndex: "unit",
    key: "unit",
    width: 140,
    ellipsis: false,
    render: (value) => <ReadOnlyCell value={value} />,
  },
  {
    title: "ESTUDIO MERCADO",
    dataIndex: "market_study",
    key: "market_study",
    width: 180,
    align: "center",
    render: (value) => <ReadOnlyCell value={value} />,
  },
  {
    title: "PRECIO MIN",
    dataIndex: "price_min",
    key: "price_min",
    width: 150,
    align: "right",
    render: (value, record) =>
      record?.market_study === "NO" ? <ReadOnlyCell value="---" /> : <CurrencyCell value={value} />,
  },
  {
    title: "PRECIO MAX",
    dataIndex: "price_max",
    key: "price_max",
    width: 150,
    align: "right",
    render: (value, record) =>
      record?.market_study === "NO" ? <ReadOnlyCell value="---" /> : <CurrencyCell value={value} />,
  },
  {
    title: "PRECIO PROVEEDOR",
    dataIndex: "price",
    key: "price",
    width: 170,
    align: "right",
    render: (value) => <CurrencyCell value={value} />,
  },
  {
    title: "ESTADO",
    dataIndex: "status_supervision",
    key: "status_supervision",
    width: 130,
    align: "center",
    render: (value) => <StatusCell value={value} />,
  },
  {
    title: "OBSERVACION SUPERVISION",
    dataIndex: "observations_supervision",
    key: "observations_supervision",
    width: 280,
    ellipsis: false,
    render: (value) => <ObservationCell value={value} />,
  },
];
